<div class="w-full mt-4">
    <div [ngClass]="classSelect()" class=" items-center my-1">{{title}}</div>
    <div [ngClass]="classSelect()" class=" rounded-md border-{{valid}} border-x border-y px-2">


        <div  class="flex justify-around items-center w-full mdm:flex mdm:flex-col mdm:gap-2">
            <button *ngIf="actions.add" mat-icon-button type="button" color="{{valid}}" class="p-1">
                <label for="attach{{name}}">
                    <mat-icon style="cursor: pointer !important;"> attach_file </mat-icon>
                </label>
            </button>

            <div [ngClass]="{'ml-2': !actions.adjunto}" class="justify-start items-center">

                <small class="text-mute w-[50%] mdm:w-10 pl-2"><b>{{text}}</b></small>
                <input id="attach{{name}}" style="display: none;" type="file" accept=".{{type}}"
                    (change)="onAddAdjunto($event)">
            </div>

            <button mat-icon-button matTooltip='Ver adjunto' *ngIf='verAdjunto && preview' 
                (click)='verDocumento()'>
                <mat-icon svgIcon="heroicons_outline:eye"></mat-icon>
            </button>

            <button mat-icon-button matTooltip='Ver adjunto' *ngIf='!verAdjunto && preview' 
                (click)='verDocumento()'>
                <mat-icon svgIcon="heroicons_outline:eye-off"></mat-icon>
            </button>


            <button mat-icon-button matTooltip='Eliminar Adjunto' *ngIf='preview && actions.delete'  color="warn"
                (click)='remove_attach($event.target.id)'>
                <mat-icon id="preview">close</mat-icon>
            </button>
        </div>
        
        <div *ngIf="start!='closed'">
            <div class='attach-overlay' *ngIf='verAdjunto'>
                <object [data]="preview | safe: 'resourceUrl'" type="{{prefix}}/{{this.extensionReal}}" width="100%"
                    height="596px"></object>
            </div>
        </div>
    </div>
</div>